var React = require('react');

function Cancel (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 12L19 19M5 19L12 12L5 19ZM19 5L12 12L19 5ZM12 12L5 5L12 12Z","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Cancel.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Cancel;

Cancel.default = Cancel;
